import { render, staticRenderFns } from "./FormDependentDocuments.vue?vue&type=template&id=c65e8622"
import script from "./FormDependentDocuments.vue?vue&type=script&lang=js"
export * from "./FormDependentDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports